import { ListBase, ListToolbar, Title, useListContext } from "react-admin";
import Maps from "../../../ui/maps";
import CustomListFilterToolbar from '../../../ui/custom-list-filter-toolbar';
import CustomFilterSpotDownloadMap from '../../../filter/custom-filter-spot-download-map';

const WrapperMap = () =>
{
  const { data, error, isLoading } = useListContext();
  if (isLoading) return null;
  if (error) return <span>Error: {error}</span>

  return (
    <Maps
      markers={data.map((item) =>
      {
        return {
          id: item.id,
          item_name: item.spot.name,
          customer_name: item.customer.profile.name,
          date: item.created_at_format,
          lat: item.lat,
          lng: item.lng,
          city: item.city
        };
      })}
    />
  );
};

const SpotDownloadMapList = () => {
  return (
    <ListBase>
      <ListToolbar
        filters={CustomFilterSpotDownloadMap}
        actions={<CustomListFilterToolbar />} />
      <Title
        title="Mapa de Download de Spot" />
      <WrapperMap />
    </ListBase>
  )
}

export default SpotDownloadMapList;
